export default __webpack_public_path__ + "static/media/DOOR_SENSOR_ZIGBEE.78e8d9b6.png";